import { FullListing } from '@th/shared/src/types/FullListing';
import React from 'react';

type Props = {
  listing: FullListing;
};
export default function DefaultBrokerageFooter({ listing }: Props) {
  return (
    <div className="pb-4">
      <div>
        <p>Data is provided courtesy of {listing.realEstateBoardName()}</p>
        <p>
          The information contained in this listing should be verified by the
          buyer
        </p>
        <p>Behnam Amirghassemi, Sutton Group-Admiral Realty Inc. Brokerage</p>
      </div>
    </div>
  );
}
